export class PaymentRoutes {
    constructor(basePath) {
        this.orderIdParam = ":orderId";
        this.paymentTokenParam = ":paymentToken";
        this.root = `${basePath}payment`;
        this.failed = "failed";
        this.success = "success";
    }
    get basePath() {
        return `${this.root}/${this.orderIdParam}`;
    }
    getBaseUrl(orderId) {
        return `${this.root}/${orderId}`;
    }
    get failedPaymentPath() {
        return `${this.basePath}/${this.failed}`;
    }
    getFailedPaymentUrl(orderId) {
        return `${this.root}/${orderId}/${this.failed}`;
    }
    get successPaymentPath() {
        return `${this.basePath}/${this.paymentTokenParam}/${this.success}`;
    }
    getSuccessPaymentUrl(orderId, paymentToken) {
        return `${this.root}/${orderId}/${paymentToken}/${this.success}`;
    }
}
//# sourceMappingURL=PaymentRoutes.js.map